import dataFormat from "../custom/DataFormat.json";

// python string의 strip메소드와 비슷한 역할을 하는 함수.
export const Strip = (word: string, characters: string = " ") => {
  return RStrip(LStrip(word, characters), characters);
};

// python string의 lstrip메소드와 비슷한 역할을 하는 함수.
export const LStrip = (word: string, characters: string = " ") => {
  let newWord = word;
  while (newWord.length > characters.length) {
    if (newWord.slice(0, characters.length) === characters) {
      newWord = newWord.slice(characters.length, newWord.length);
    } else {
      break;
    }
  }
  return newWord;
};

// python string의 rstrip메소드와 비슷한 역할을 하는 함수.
export const RStrip = (word: string, characters: string = " ") => {
  let newWord = word;
  while (newWord.length > characters.length) {
    if (
      newWord.slice(newWord.length - characters.length, newWord.length) ===
      characters
    ) {
      newWord = newWord.slice(0, newWord.length - characters.length);
    } else {
      break;
    }
  }
  return newWord;
};

export const Capitalize = (word: string | undefined) => {
  if (word === undefined) return word;
  let newWord = word.charAt(0).toUpperCase() + word.slice(1);
  return newWord;
};

export const CapitalizeAll = (word: string) => {
  return word.replace(/\b\w/g, char => char.toUpperCase());
};

export const RemoveUnderScore = (word: string) => {
  return word.replace(/_/g, " ");
};

export const RemoveDash = (word: string) => {
  return word.replace(/-/g, " ");
};

export const RemoveBracket = (word: string) => {
  return word.replace(/\(|\)/g, " ");
};

export const RemoveAllSpace = (word: string) => {
  return word.replace(/\s/g, " ");
};

export const RemovePeriod = (word: string) => {
  return word.replace(/\./g, " ");
};

export const ByPass = (word: string) => {
  return word;
};

export const RemoveTerm = (word: string, term: RegExp) => {
  return word.replace(term, "");
};

export const AddPrefix = (word: string, prefix: string) => {
  return prefix + word;
};

export const AddSuffix = (word: string, suffix: string) => {
  return word + suffix;
};

export const ConvertToCurrency = (word: string, currency: string) => {
  if (!isNaN(Number(word.replace(/,/g, "")))) {
    return `${currency} ${Number(word.replace(/,/g, "")).toLocaleString("ko-KR")}`;
  }
  return word;
};

const functionMap: { [key: string]: (...args: any[]) => string } = {
  ByPass: ByPass,
  RStrip: (name: string, param: string) => RStrip(name, param),
  LStrip: (name: string, param: string) => LStrip(name, param),
  Strip: (name: string, param: string) => Strip(name, param),
  RemoveTerm: (name: string, param: string) =>
    RemoveTerm(name, new RegExp(param)),
  RemoveDash: RemoveDash,
  CapitalizeAll: CapitalizeAll,
  RemoveUnderScore: RemoveUnderScore,
  RemoveBracket: RemoveBracket,
  RemovePeriod: RemovePeriod,
  RemoveAllSpace: RemoveAllSpace,
  AddPrefix: (name: string, param: string) => AddPrefix(name, param),
  AddSuffix: (name: string, param: string) => AddSuffix(name, param),
  ConvertToCurrency: ConvertToCurrency,
};

export const ModelNameFormatter = (modelName: string) => {
  const functions: ((name: string) => string)[] = [];
  const modelNameConfig = dataFormat.modelName.functions;

  modelNameConfig.forEach(([funcName, param]) => {
    const func = functionMap[funcName];
    if (func) {
      functions.push((name: string) => func(name, param));
    }
  });

  let newName = modelName;

  functions.forEach(func => {
    newName = func(newName);
  });

  return newName;
};

export const KeyFormatter = (key: string) => {
  const functions: ((name: string) => string)[] = [];
  const keyConfig = dataFormat.key.functions;

  keyConfig.forEach(([funcName, param]) => {
    const func = functionMap[funcName];
    if (func) {
      functions.push((name: string) => func(name, param));
    }
  });

  let newKey = key;

  functions.forEach(func => {
    newKey = func(newKey);
  });

  return newKey;
};

export const ValueFormatter = (value: string) => {
  const functions: ((name: string) => string)[] = [];
  const valueConfig = dataFormat.value.functions;
  if (valueConfig.length === 0) return value;
  else {
    valueConfig.forEach(([funcName, param]) => {
      const func = functionMap[funcName];
      if (func) {
        functions.push((name: string) => func(name, param));
      }
    });

    let newValue = value;

    functions.forEach(func => {
      newValue = func(newValue);
    });

    return newValue;
  }
};
